/* src/app/modules/contact/contact/booking-contact-sync-dialog.component.css */
.bcs-header-text {
  min-width: 0;
  padding-right: 36px;
}
.bcs-error {
  margin-bottom: 0;
}
.bcs-cols,
.bcs-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 40px minmax(0, 1fr);
  column-gap: 8px;
}
.bcs-cols {
  margin-bottom: 12px;
}
.bcs-col-hdr {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.bcs-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.bcs-icon--factu {
  color: #4d7a00;
}
.bcs-icon--bookcit {
  color: #2563eb;
}
.bcs-label {
  margin-top: 8px;
}
.bcs-cell {
  min-width: 0;
}
.bcs-arrows {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 0;
}
.bcs-arrow-btn {
  color: #9ca3af !important;
  width: 28px !important;
  height: 28px !important;
  line-height: 28px !important;
  padding: 2px !important;
}
.bcs-arrow-btn:hover {
  color: #2563eb !important;
}
.bcs-arrow-btn mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}
@media (max-width: 600px) {
  .bcs-cols {
    display: none;
  }
  .bcs-row {
    grid-template-columns: minmax(0, 1fr);
  }
  .bcs-arrows {
    flex-direction: row;
    justify-content: center;
    gap: 16px;
    margin: -12px 0 8px;
  }
  .bcs-arrow-btn mat-icon {
    transform: rotate(90deg);
  }
}
/*# sourceMappingURL=booking-contact-sync-dialog.component.css.map */
